import { render, staticRenderFns } from "./curva-s.vue?vue&type=template&id=b6d89f5a&"
import script from "./curva-s.vue?vue&type=script&lang=js&"
export * from "./curva-s.vue?vue&type=script&lang=js&"
import style0 from "./curva-s.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports